module.exports = __webpack_public_path__ + "img/info-item-1.336cc90d.png";